import { collection, getDocs, doc, setDoc } from 'firebase/firestore';
import { v4 as uuidv4 } from 'uuid';
import { db } from '../firebase';

/**
 * addHalachicTimesWidgetToCatalog
 * מוסיף את HalachicTimesWidget לקטלוג APP-CATALOG ב-Firestore.
 * אם הרכיב כבר קיים — מעדכן את התבניות (upsert).
 */
export const addHalachicTimesWidgetToCatalog = async () => {
  const snapshot = await getDocs(collection(db, 'APP-CATALOG'));

  let existing = null;
  snapshot.forEach(d => {
    if (d.data().componentKey === 'HalachicTimesWidget') {
      existing = { id: d.id, ...d.data() };
    }
  });

  const templates = [
    { id: uuidv4(), name: 'Classic' },
    { id: uuidv4(), name: 'Royal' },
    { id: uuidv4(), name: 'Parchment' },
    { id: uuidv4(), name: 'Elegant' },
    { id: uuidv4(), name: 'Modern' },
    { id: uuidv4(), name: 'Columns' },
    { id: uuidv4(), name: 'Ribbon' },
    { id: uuidv4(), name: 'Banner' },
  ];

  if (existing) {
    await setDoc(doc(db, 'APP-CATALOG', existing.id), {
      ...existing,
      templates,
    });
    return { message: 'HalachicTimesWidget עודכן בקטלוג (תבניות סונכרנו)', appId: existing.id };
  }

  const appId = uuidv4();
  const entry = {
    appId,
    componentKey: 'HalachicTimesWidget',
    name: 'זמני היום ההלכתיים',
    dashboardLayout: { w: 6, h: 10 },
    templates,
    defaultProps: {
      visibleZmanim: null,
    },
  };

  await setDoc(doc(db, 'APP-CATALOG', appId), entry);

  return { message: 'HalachicTimesWidget נוסף לקטלוג בהצלחה', appId };
};
